import React, { useEffect, useMemo } from "react";
import { useLiveConfig } from "../hooks/useLiveConfig";
import { hasLiveEventEnded } from "../utils/liveVideoUtils";
import { EventEndedCurtain } from "./EventEndedCurtain";
import { useVideoDataContext } from "../contexts/VideoDataContext";
import PropTypes from "prop-types";
import { OrcaFullUI } from "./OrcaFullUI";
import { DataLayer } from "./DataLayer";
import { useOrcaCommonContext } from "../contexts/OrcaCommonContext";
import { OrcaWrapper } from "./OrcaWrapper";

export const LivePlayer = ({ config, orcaRef, promoEnabled }) => {
  const { videoData } = useVideoDataContext();
  const { reset, playerState, playerSize } = useOrcaCommonContext();

  useLiveConfig(config, orcaRef);

  // Render EventEndedCurtain and stop playing the video stream if Orca is playing a live event that has ended
  const liveEventEnded = useMemo(() => {
    return hasLiveEventEnded(videoData);
  }, [videoData]);

  useEffect(() => {
    if (liveEventEnded) reset();
  }, [liveEventEnded, playerState.isPlaying]);

  return (
    <OrcaWrapper config={config}>
      {liveEventEnded && <EventEndedCurtain playerSize={playerSize} />}

      <OrcaFullUI
        config={config}
        promoEnabled={promoEnabled}
        isLive={true}
        liveEventEnded={liveEventEnded}
        ref={orcaRef}
      />

      <DataLayer playerState={playerState} isLive={true} />
    </OrcaWrapper>
  );
};

LivePlayer.propTypes = {
  config: PropTypes.object.isRequired,
  orcaRef: PropTypes.object,
  promoEnabled: PropTypes.bool
};
